import { Component, OnInit, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';

import { SHARED_IMPORTS } from '../shared/shared-imports';
import { ContentService } from '../../services/content.service';
import { UiHelperService } from '../../services/ui-helper.service';

@Component({
	standalone: true,
	selector: 'tenant-detail',
	templateUrl: 'components/tenant-detail/tenant-detail.component.html',
	styleUrls: ['components/tenant-detail/tenant-detail.component.css'],
	imports: [
		...SHARED_IMPORTS,
		MatSlideToggleModule,
		MatButtonModule,
		MatSelectModule,
		MatFormFieldModule,
		MatInputModule,
		MatIconModule
	]
})
export class TenantDetailComponent implements OnInit {

	private router = inject(Router);
	private http = inject(HttpClient);
	private uiHelper = inject(UiHelperService);
	private content = inject(ContentService);

	Tenant: any = {};
	readMode = true;
	Languages: any[] = [];
	TimeZones: any[] = [];




	constructor() { }


	ngOnInit(): void {
		this.getTenantDetailVM();
	}

	getTenantDetailVM(): void {
		this.http.get('/api/Tenant/TenantDetailVM').subscribe((result: any) => {
			this.Languages = result.Languages;
			this.TimeZones = result.TimeZones;
			this.Tenant = result.Tenant;

			for (let lang of this.Languages) {
				lang.LanguageName = this.content.getContent(`TenantDetail.${lang.LanguageName}`);
			}
			this.Tenant.AppLanguage = this.Languages.find(
				l => l.Id === this.Tenant.AppLanguage?.Id
			) ?? this.Tenant.AppLanguage;

			this.Tenant.AppTimeZone = this.TimeZones.find(
				tz => tz.Id === this.Tenant.AppTimeZone?.Id
			) ?? this.Tenant.AppTimeZone;

		});
	}

	switchMode(): void {
		this.readMode = !this.readMode;
		if (!this.readMode) this.uiHelper.info('TenantDetail.ReadModeEntered');
	}

	goBack(): void {
		this.router.navigate(['/Main']);
	}

	updateTenantName(): void {
		this.updateSimple('TenantName');
	}

	updateShowSiteLevel(): void {
		this.updateSimple('ShowSiteLevel');
	}

	updateAppLanguage(): void {
		const langId = this.Tenant.AppLanguage?.Id;
		if (langId) {
			this.updateDropdown('AppLanguage', () => this.content.clearAllAndReload());
		}
	}

	updateAppTimeZone(): void {
		this.updateDropdown('AppTimeZone');
	}

	private updateSimple(attribute: string): void {
		const postData: any = {};
		postData[attribute] = this.Tenant[attribute];
		this.http.post(`/api/Tenant/Update${attribute}`, postData).subscribe(() => {
			this.uiHelper.info(`TenantDetail.${attribute}WasUpdated`);
		});
	}

	private updateDropdown(attribute: string, onUpdate?: () => void): void {
		const attributeWithId = `${attribute}Id`;
		const postData: any = {};
		postData[attributeWithId] = this.Tenant[attribute]?.Id;

		this.http.post(`/api/Tenant/Update${attributeWithId}`, postData).subscribe(() => {
			this.uiHelper.info(`TenantDetail.${attributeWithId}WasUpdated`);
			if (onUpdate) onUpdate();
		});
	}
}
